import { DollhouseStore } from '../../store/index.js';

import { DollhouseContext } from './DollhouseContext.js';

export interface DollhouseProviderProps {
  store: DollhouseStore;
  children: React.ReactNode;
}

export const DollhouseProvider: React.FC<DollhouseProviderProps> = ({
  children,
  store,
}: DollhouseProviderProps) => {
  return <DollhouseContext.Provider value={store}>{children}</DollhouseContext.Provider>;
};
